import { render } from "./assetcategorylist.vue?vue&type=template&id=222e2901"
import script from "./assetcategorylist.vue?vue&type=script&lang=js"
export * from "./assetcategorylist.vue?vue&type=script&lang=js"

import "./assetcategorylist.vue?vue&type=style&index=0&id=222e2901&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__